export const ROLES = {
  ADMIN: 'ADMIN',
  TRUONG_NGANH: 'TRUONG_NGANH',
  GVCN: 'GVCN',
  GV_PHU: 'GV_PHU',
};

export const CHUA_DIEM_DANH = {
  key: null,
  label: 'Chưa ĐD',
  icon: '❓',
  color: '#9E9E9E',
  bg: '#F5F5F5',
};

export const TRANG_THAI_DIEM_DANH = {
  coMat: { key: 'coMat', label: 'Có mặt', icon: '✅', color: '#4CAF50', bg: '#E8F5E9' },
  vangPhep: { key: 'vangPhep', label: 'Vắng phép', icon: '📝', color: '#FF9800', bg: '#FFF3E0' },
  diTre: { key: 'diTre', label: 'Đi trễ', icon: '⏰', color: '#2196F3', bg: '#E3F2FD' },
  vangKhongPhep: { key: 'vangKhongPhep', label: 'Vắng KP', icon: '❌', color: '#F44336', bg: '#FFEBEE' },
};

export const LOAI_DIEM = {
  mieng: { key: 'mieng', label: 'Miệng', heSo: 1 },
  '15phut': { key: '15phut', label: '15 phút', heSo: 1 },
  '1tiet': { key: '1tiet', label: '1 tiết', heSo: 2 },
  hocKy: { key: 'hocKy', label: 'Học kỳ', heSo: 3 },
};

export const HOC_KY = { HK1: 'HK1', HK2: 'HK2' };

export const TRANG_THAI_HD = { DANG_HOAT_DONG: 'dangHoatDong', NGHI: 'nghi' };

export const TRANG_THAI_NAM_HOC = { DANG_HOAT_DONG: 'dangHoatDong', KET_THUC: 'ketThuc' };

export const PERMISSIONS = {
  [ROLES.ADMIN]: { xemTatCa: true, suaTatCa: true, diemDanh: true, nhapDiem: true, quanLyHS: true, baoCao: true, quanLyNamHoc: true, quanLyNguoiDung: true },
  [ROLES.TRUONG_NGANH]: { xemNganhMinh: true, baoCao: true },
  [ROLES.GVCN]: { diemDanh: true, nhapDiem: true, quanLyHS: true, baoCao: true },
  [ROLES.GV_PHU]: { diemDanh: true },
};
